export const enum SETTLEMENT_STATUS {
  LiquidacionGenerada = "Liquidación generada",
  EnProceso = "En proceso",
  Enviada = "Enviada",
  EnVerificacion = "En verificación",
  ASubsanar = "A subsanar",
  PendienteDeSubsanacion = "Pendiente de subsanación",
  AprobadaAutomaticamente = "Aprobada automáticamente",
  AprobadaManualmente = "Aprobada manualmente",
}

export type SettlementStatusT = keyof typeof SETTLEMENT_STATUS;
